export function isVersionedResource(resource) {
  return !['exports', 'files', 'tenants', 'profile', 'validator'].includes(
    resource
  );
}

// Helper function to toggle a save property while a save is happening.
// The call is ignored if the property is already true.
export async function whileSaving(that, property, saveFn) {
  if (that[property]) {
    // Already saving
    return;
  }

  try {
    that[property] = true;
    return await saveFn();
  } finally {
    that[property] = false;
  }
}
